module.exports.location = "phantom\\bin\\phantomjs.exe"
module.exports.platform = "win32"
module.exports.arch = "x64"
